import React from 'react';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  primary?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  fullWidth?: boolean;
}

/* 旧 styled-components `StyledButton` の共通部分。
 * font-size は line-height 未指定だったため arbitrary value で保持する。 */
const BUTTON_BASE =
  'px-4 py-2 text-[0.875rem] font-medium rounded-tasky-sm [font-family:inherit] ' +
  'cursor-pointer transition-all duration-200 focus:outline-none ' +
  'disabled:cursor-not-allowed disabled:opacity-60';

/* $primary === true */
const BUTTON_PRIMARY =
  'bg-primary text-white border border-primary ' +
  'enabled:hover:bg-primary-hover ' +
  'focus:shadow-[0_0_0_2px_rgba(97,111,201,0.5)]';

/* $primary === false */
const BUTTON_DEFAULT =
  'bg-white text-dark border border-border ' +
  'enabled:hover:bg-muted ' +
  'focus:shadow-[0_0_0_2px_rgba(228,228,231,0.5)]';

export const Button: React.FC<ButtonProps> = ({
  primary = false,
  disabled = false,
  children,
  onClick,
  type = 'button',
  fullWidth = false,
  className,
  ...props
}) => {
  return (
    <button
      type={type}
      className={[
        BUTTON_BASE,
        primary ? BUTTON_PRIMARY : BUTTON_DEFAULT,
        fullWidth ? 'w-full' : 'w-auto',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      disabled={disabled}
      onClick={onClick}
      data-variant={primary ? 'primary' : 'default'}
      {...props}
    >
      {children}
    </button>
  );
};
